var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39809 13.7955L0.200637 7.47727C0.126327 7.40151 0.0743101 7.32576 0.0445862 7.25C0.0148622 7.17424 0 7.09091 0 7C0 6.90909 0.0148622 6.82576 0.0445862 6.75C0.0743101 6.67424 0.126327 6.59848 0.200637 6.52273L6.42038 0.181818C6.53928 0.0606059 6.6879 0 6.86624 0C7.04459 0 7.20064 0.0681817 7.33439 0.204545C7.46815 0.340909 7.53503 0.5 7.53503 0.681818C7.53503 0.863636 7.46815 1.02273 7.33439 1.15909L2.27389 6.31818H13.3312C13.5244 6.31818 13.6842 6.38258 13.8105 6.51136C13.9368 6.64015 14 6.80303 14 7C14 7.19697 13.9368 7.35985 13.8105 7.48864C13.6842 7.61742 13.5244 7.68182 13.3312 7.68182H2.27389L7.35669 12.8636C7.47558 12.9848 7.53503 13.1364 7.53503 13.3182C7.53503 13.5 7.46815 13.6591 7.33439 13.7955C7.20064 13.9318 7.04459 14 6.86624 14C6.6879 14 6.53185 13.9318 6.39809 13.7955Z",
    fill: "#550087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft2);
export default __webpack_public_path__ + "static/media/arrow-left2.17df64f4129dc402b7b423a2efa5d587.svg";
export { ForwardRef as ReactComponent };